import React from 'react';
import ModalNew from '../../../../../components/ui/popup/Modal';
import { PopupContent, PopupHeader, PopupSection } from '../../../../../components/ui/popup/common';
import LoadingPlaceholder from '../../../../../components/ui/loading/LoadingPlaceholder';


const RequestSignatureModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  isLoading, 
  error, 
  success 
}) => {
  if (!isOpen) return null;

  return (
    <ModalNew className="content-modal" style={{ maxWidth: "480px" }}>
      <PopupHeader
        title="Request Signature"
        setOpenState={onClose}
        icon={`${process.env.PUBLIC_URL}/images/icons/news_blue_popup.svg`}
        variant="compact"
      />
      <PopupContent>
        {/* Confirmation State */}
        {!isLoading && !error && !success && (
          <PopupSection>
            <p className="popup-description" style={{ marginBottom: "24px" }}>
              Are you sure you want to request the taxpayer's signature? 
              They will be notified via email to sign the Form 8879.
            </p>
            <div className="popup-actions">
              <button type="button" className="cta-button secondary short" onClick={onClose}>
                Cancel
              </button>
              <button type="button" className="cta-button primary short" onClick={onConfirm}>
                Request Signature
              </button>
            </div>
          </PopupSection>
        )}

        {/* Loading State */}
        {isLoading && !error && !success && (
          <PopupSection>
            <LoadingPlaceholder rows={1} type="line" />
            <p className="popup-description" style={{ marginTop: "16px", textAlign: "center" }}>
              Requesting signature from taxpayer...
            </p>
          </PopupSection>
        )}

        {/* Success State */}
        {success && (
          <PopupSection style={{ textAlign: "center" }}>
            <p className="popup-success-title">✓ Success!</p>
            <p className="popup-description">
              Signature request sent successfully! The taxpayer will be notified.
            </p>
            <div className="popup-actions" style={{ justifyContent: "center", marginTop: "24px" }}>
              <button type="button" className="cta-button primary short" onClick={onClose}>
                Close
              </button>
            </div>
          </PopupSection>
        )}

        {/* Error State */}
        {error && (
          <PopupSection style={{ textAlign: "center" }}>
            <p className="popup-error-title">✗ Error</p>
            <p className="popup-description">{error}</p>
            <div className="popup-actions" style={{ justifyContent: "center", marginTop: "24px" }}>
              <button type="button" className="cta-button secondary short" onClick={onClose}>
                Close
              </button>
              <button type="button" className="cta-button primary short" onClick={onConfirm}>
                Try Again
              </button>
            </div>
          </PopupSection>
        )}
      </PopupContent>
    </ModalNew>
  );
};

export default RequestSignatureModal;